import URLJoin from "url-join"

// ----------------------------------------------------------------------------

const DEBUG_API = false

const DEFAULT_API_PORT = "9001"
export const BASE_URL = getBaseURL()
const ACCESS_TOKEN = "1b87abf1-9ba1-44ba-9811-87ed7d43243f"
const API_KEY = "secret"
export const USER_AUTH_HEADER = `apiKey ${API_KEY}`

// ----------------------------------------------------------------------------

function getBaseURL() {
    if (process.env.NODE_ENV === "development") {
        return `http://localhost:${DEFAULT_API_PORT}` //`http://15.160.21.119/api`
    } else {
        return `https://prenota.welfarecare.org/api`

        // return `https://welfarecare-prenota.no-gravity.dev/api`
    }
}

// ----------------------------------------------------------------------------

export class APINotOkError extends Error {
    constructor(statusCode, serverResponse) {
        const message =
            (serverResponse && serverResponse.message) ||
            `HTTP status code: ${statusCode}`
        super(message)
        this.name = "APINotOkError"
        this.statusCode = statusCode
        this.serverMessage = serverResponse && serverResponse.state
        this.errorKey = serverResponse && serverResponse.key
    }
}

// ----------------------------------------------------------------------------
// Auth
// ----------------------------------------------------------------------------

export function signUp({ ...userBody }) {
    const headers = {
        Authorization: `apiKey ${API_KEY}`,
    }
    const body = {
        ...userBody,
        access_token: ACCESS_TOKEN,
    }

    return executePOSTRequest(URLJoin(BASE_URL, "/users"), null, body, headers)
}

export function signIn(email, password) {
    const base64 = require("js-base64").Base64
    var encoded = base64.encode(`${email}:${password}`)
    const headers = {
        Authorization: `Basic ${encoded}`,
    }

    const body = { access_token: ACCESS_TOKEN }

    return executePOSTRequest(URLJoin(BASE_URL, "/auth"), null, body, headers)
}

export function signInAsAgent(eventId, agentsAccessCode) {
    return executePOSTRequest(URLJoin(BASE_URL, "/events/agents-auth"), null, {
        eventId,
        agentsAccessCode,
    })
}

export function validateAndCreateUser(fiscalCode) {
    const headers = {
        Authorization: `apiKey ${API_KEY}`,
    }
    const body = { fiscalCode }

    return executePOSTRequest(URLJoin(BASE_URL, `/users`), null, body, headers)
}

// ----------------------------------------------------------------------------
// Users
// ----------------------------------------------------------------------------

export function createAdminUser({ email, password, name, surname }) {
    const body = {
        email,
        password,
        name,
        surname,
        role: "admin",
    }

    return signUp(body)
}

export function getUser(userId, token) {
    let url = `users/${userId}`

    return executeGETRequest(url, token)
}

export function updateUser(userId, body, token) {
    const relativeUrl = `/users/${userId}`

    const url = URLJoin(BASE_URL, relativeUrl)

    return executePUTRequest(url, token, body)
}

// ----------------------------------------------------------------------------
// Logs
// ----------------------------------------------------------------------------

export function getLogs(query, page = 1, token) {
    const params = new URLSearchParams({ page })
    for (const key in query) {
        if (query[key]) {
            params.append(key, query[key])
        }
    }
    const rUrl = `/logs?${params.toString()}`
    const url = URLJoin(getBaseURL(), rUrl)
    return executeGETRequest(url, token)
}

export function getLogPaths(token) {
    const rUrl = `/logs/paths`
    const url = URLJoin(getBaseURL(), rUrl)
    return executeGETRequest(url, token)
}

// ----------------------------------------------------------------------------
// Uploads
// ----------------------------------------------------------------------------

export async function uploadFile(file, token, path = "") {
    const relativeUrl = `/uploads`

    const url = URLJoin(BASE_URL, relativeUrl)

    const body = {
        file,
        path,
    }

    return executeFormDataRequest(url, "POST", null, body, token)
}

export async function deleteRemoteFile(fileUrl, token) {
    const relativeUrl = `/uploads?url=${fileUrl}`

    const url = URLJoin(BASE_URL, relativeUrl)

    return executeDELETERequest(url, token)
}

// ----------------------------------------------------------------------------
// Email templates
// ----------------------------------------------------------------------------

export function createEmailTemplate(body, token) {
    const relativeUrl = "/email-templates"
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePOSTRequest(url, token, body)
}

export function deleteEmailTemplate(id, token) {
    const relativeUrl = `/email-templates/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executeDELETERequest(url, token)
}

export function updateEmailTemplate(id, body, token) {
    const relativeUrl = `/email-templates/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePUTRequest(url, token, body)
}

// ----------------------------------------------------------------------------
// Events
// ----------------------------------------------------------------------------

export function createEvent(body, token) {
    const relativeUrl = "/events"
    const url = URLJoin(getBaseURL(), relativeUrl)

    const headers = {
        Authorization: USER_AUTH_HEADER,
    }

    return executePOSTRequest(url, token, body, headers)
}

export function deleteEvent(id, token) {
    const relativeUrl = `/events/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executeDELETERequest(url, token)
}

export function updateEvent(id, body, token) {
    const relativeUrl = `/events/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePUTRequest(url, token, body)
}

export function getExportSheet(id, token) {
    const relativeUrl = `/events/${id}/bookings/export`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executeGETRequest(url, token)
}

// ----------------------------------------------------------------------------
// Slots
// ----------------------------------------------------------------------------

export function getCanBookSlot(id, token) {
    const relativeUrl = `/slots/${id}/can-book`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executeGETRequest(url, token)
}

export function getSlot(id, token) {
    const relativeUrl = `/slots/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executeGETRequest(url, token)
}

export function lockSlot(id, token) {
    const relativeUrl = `/slots/${id}/lock`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePUTRequest(url, token)
}

export function unlockSlotAsAdmin(slotId, token) {
    const relativeUrl = `/slots/${slotId}/unlock`
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executePUTRequest(url, token)
}

// ----------------------------------------------------------------------------
// Bookings
// ----------------------------------------------------------------------------

export function createBooking(targetEventId, body, token) {
    const relativeUrl = "/bookings"
    const url = URLJoin(getBaseURL(), relativeUrl)
    const finalBody = { ...body, eventId: targetEventId }
    return executePOSTRequest(url, token, finalBody)
}

export function deleteBooking(userId, bookingId) {
    const relativeUrl = `/bookings/${bookingId}`
    const url = URLJoin(getBaseURL(), relativeUrl)
    const headers = {
        Authorization: USER_AUTH_HEADER,
        User: userId,
    }
    return executeDELETERequest(url, "", headers)
}

export function deleteBookingAsAdmin(bookingId, token) {
    const relativeUrl = `/bookings/admin/${bookingId}`
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executeDELETERequest(url, token)
}

export function switchSlot(oldSlotId, newSlotId) {
    const relativeUrl = "/bookings/switch-slot"
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePOSTRequest(url, USER_AUTH_HEADER, { oldSlotId, newSlotId })
}

export function updateBookingBio(newBody, bookingId, { userId, adminToken }) {
    const baseUrl = getBaseURL()
    if (userId) {
        const url = URLJoin(
            baseUrl,
            `/bookings/update-booking-data/user/${bookingId}`
        )
        return executePUTRequest(url, USER_AUTH_HEADER, newBody, {
            user: userId,
        })
    } else if (adminToken) {
        const url = URLJoin(
            baseUrl,
            `/bookings/update-booking-data/admin/${bookingId}`
        )
        return executePUTRequest(url, adminToken, newBody)
    } else {
        throw new Error("No auth info provided")
    }
}

export function notifyParticipants(mailBody, subject, eventId, token) {
    const url = URLJoin(getBaseURL(), `/events/mail-participants/${eventId}`)

    return executePOSTRequest(url, token, { mailBody, subject })
}

// ----------------------------------------------------------------------------
// Documents
// ----------------------------------------------------------------------------

export function createDocument(body, token) {
    const relativeUrl = "/documents"
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executePOSTRequest(url, token, body)
}

export function updateDocument(id, body, token) {
    const relativeUrl = `/documents/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePUTRequest(url, token, body)
}

export function deleteDocument(id, token) {
    const relativeUrl = `/documents/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executeDELETERequest(url, token)
}

// ----------------------------------------------------------------------------
// Event types
// ----------------------------------------------------------------------------

export function createEventType(body, token) {
    const relativeUrl = "/event-types"
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executePOSTRequest(url, token, body)
}

export function updateEventType(id, body, token) {
    const relativeUrl = `/event-types/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)

    return executePUTRequest(url, token, body)
}

export function deleteEventType(id, token) {
    const relativeUrl = `/event-types/${id}`
    const url = URLJoin(getBaseURL(), relativeUrl)
    return executeDELETERequest(url, token)
}

// ----------------------------------------------------------------------------
// REST Resources
// ----------------------------------------------------------------------------

export function getResourceList(resourceURI, token, options, user) {
    const { pageNumber, pageSize = 10, sort, filters } = options
    const url = URLJoin(BASE_URL, resourceURI)

    const filterParams = {}
    for (let filterKey in filters) {
        if (filters[filterKey].length) {
            if (Array.isArray(filters[filterKey])) {
                filterParams[filterKey] = filters[filterKey].join(",")
            } else {
                filterParams[filterKey] = filters[filterKey]
            }
        }
    }

    const params = {
        ...filterParams,
        limit: pageSize,
    }

    if (pageNumber) {
        params.page = pageNumber
    }

    if (sort) {
        const sortOperator = sort.order === "descend" ? "-" : "+"
        params.sort = `${sortOperator}${sort.key}`
    }

    const urlWithQuery = urlWithQueryParams(url, params)
    return executeGETRequest(
        urlWithQuery,
        token,
        { isList: true },
        user ? { User: `${user.id}` } : null
    )
}

export function getResource(resourceURI, token, user) {
    const url = URLJoin(BASE_URL, resourceURI)
    return executeGETRequest(
        url,
        token,
        { isList: false },
        user ? { User: `${user.id}` } : null
    )
}

export function createResource(resourceURI, token, resource) {
    const url = URLJoin(BASE_URL, resourceURI)
    return executePOSTRequest(url, token, resource)
}

export function updateResource(resourceURI, token, resourceID, resource) {
    const url = URLJoin(BASE_URL, resourceURI, resourceID)

    return executePUTRequest(url, token, resource)
}

export function deleteResource(resourceURI, token, resourceID) {
    const url = URLJoin(BASE_URL, resourceURI, resourceID)
    return executeDELETERequest(url, token)
}

// ----------------------------------------------------------------------------
// Private helpers
// ----------------------------------------------------------------------------

function executeGETRequest(url, token, options, extraHeaders) {
    const headers = {
        Authorization: token?.includes("apiKey") ? token : `Bearer ${token}`,
        ...extraHeaders,
    }

    return executeRequest(url, "get", null, headers, options)
}

function executePOSTRequest(url, token, body, headers) {
    const newHeaders = headers || {}
    if (token) {
        newHeaders["Authorization"] = token.includes("apiKey")
            ? token
            : `Bearer ${token}`
    }
    return executeRequest(url, "post", body, newHeaders)
}

function executePUTRequest(url, token, body, headers) {
    const newHeaders = headers || {}
    if (token) {
        newHeaders["Authorization"] = token.includes("apiKey")
            ? token
            : `Bearer ${token}`
    }
    return executeRequest(url, "put", body, newHeaders)
}

function executeDELETERequest(url, token, headers) {
    const defaultHeaders = {
        Authorization: `Bearer ${token}`,
    }
    return executeRequest(url, "delete", null, headers || defaultHeaders)
}

// ----------------------------------------------------------------------------

async function executeFormDataRequest(givenUrl, method, headers, body, token) {
    let url = normalizeURL(givenUrl)

    const formData = new FormData()

    // format json body into form data
    body &&
        Object.keys(body).forEach((key) => {
            if (Array.isArray(body[key])) {
                const array = body[key]

                array.forEach((data, index) => {
                    const formDataArrayKey = `${key}`
                    formData.append(formDataArrayKey, data)
                })
            } else {
                formData.append(key, body[key])
            }
        })

    const requestData = {
        method,
        headers: new Headers({
            ...headers,
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        }),

        body: formData,
    }

    try {
        const response = await fetch(url, requestData)

        let responseBody = {}

        if (response && response.ok) {
            const responseBodyText = await response.text()

            try {
                responseBody = JSON.parse(responseBodyText)
            } catch (e) {
                responseBody = responseBodyText
            }

            return responseBody
        } else {
            throw new APINotOkError(response.status, responseBody)
        }
    } catch (error) {
        throw new Error(error)
    }
}

function executeRequest(givenURL, method, givenBody, givenHeaders, options) {
    let url = normalizeURL(givenURL)
    const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...givenHeaders,
    }
    let body
    if (givenBody) {
        body = JSON.stringify(givenBody)
        if (DEBUG_API) {
            // eslint-disable-next-line
            console.debug(`[API/REQUEST/BODY]`, url, givenBody)
        }
    }
    const requestData = {
        method,
        headers,
        body,
    }
    if (DEBUG_API) {
        // eslint-disable-next-line
        console.debug(`[API/REQUEST]`, url, requestData)
    }

    return fetch(url, requestData).then((response) => {
        if (DEBUG_API) {
            // eslint-disable-next-line
            console.debug(`[API/RESPONSE]`, url, response)
        }

        return response.text().then(function (text) {
            let responseBody
            try {
                responseBody = JSON.parse(text)
            } catch (e) {
                responseBody = text
            }

            if (DEBUG_API) {
                // eslint-disable-next-line
                console.debug(`[API/RESPONSE/BODY]`, responseBody)
            }

            if (response.ok) {
                if (options && options.isList) {
                    return {
                        data: responseBody,
                    }
                } else {
                    return responseBody
                }
            } else {
                throw new APINotOkError(response.status, responseBody)
            }
        })
    })
}

// -------------------------------------

function normalizeURL(givenURL) {
    let isPathAbsolute =
        givenURL.indexOf("http://") === 0 || givenURL.indexOf("https://") === 0
    if (isPathAbsolute) {
        return givenURL
    } else {
        let baseURL = `${window.location.protocol}//${window.location.hostname}:${DEFAULT_API_PORT}`

        return URLJoin(baseURL, givenURL.replace(/^\.\//, ""))
    }
}

function urlWithQueryParams(url, params) {
    const urlParams = Object.entries(params)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&")
    return `${url}?${urlParams}`
}

// ----------------------------------------------------------------------------
